import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import Movimentacoes from './movimentacoes';
import MovimentacoesSaida from './solicitacoesRetorno';
import auth from './auth';
import Estoque from './estoque';
import EstoqueCart from './estoqueCart';
import Transportadoras from './transportadoras';
import SolicitacaoRetorno from './solicitacaoRetorno';
import Motorista from './motorista';
import Fornecedor from './fornecedor';
import persistReducer from 'redux-persist/es/persistReducer';
import produtos from './produtos';
import ColetaNoCd from './coletaNoCd';
import EntregaNoCd from './entregaNoCd';
import PagadorArmazenagem from './pagadorArmazenagem';
import Agendamentos from './agendamentos';
import CentrosDistribuicao from './centrosDistribuicao';
import TomadoresTransportadora from './tomadoresTransportadora';
import PedidoEntrega from './pedidoEntrega';
import CidadeOrigem from './cidadeOrigem';
import EstadoOrigem from './estadoOrigem';
import ListarVeiculos from './listarVeiculos';
import OrdemCarga from './ordemCarga';
import OrdemCargaPage from './ordemCargaPage';
import EstadoCidade from './estadoCidade';
import CriaAgendamento from './criaAgendamento';
import DataHoraordemDeCarga from './dataHoraordemDeCarga';
import DetalheVeiculo from './detalheVeiculo';
import Plataforma from './plataforma';
import Atendimentos from './atendimentos';
import CriarAtendimento from './criarAtendimento';
import AtendimentoMensagens from './sendMenssages';
import ConsultaAgendamentos from './consultaAgendamentos';
import Agrupamentos from './agrupamento';
import Semaphore from './semaphore';
import KPIAC from './kpiAC';
import KPIEAI from './kpiEAI';
import KPIEAE from './kpiEAE';
import KPISA from './kpiSA';
import KPISE from './kpiSE';
import SolicitacoesRetornoItensNota from './solicitacoesRetornoItensNota';
import Ocorrencia from './ocorrencia';
import ProgressBarSLA from './progressBarSLA';
import Notifications from './notifications';
import DownloadAttachment from './downloadAttachments';
import DashSla from './dashSlaAtendimento';
import Tracking from './tracking';
import BlackList from './blackList';
import CargaDescarga from './cargaDescarga';
import HorariosDisponiveis from './horariosDisponiveis';
import DetalhesOrdemCarga from './detalhesOrdemCarga';
import Depositante from './depositante'

export interface PersistConfig {
  key: string;
  storage: typeof storage;
  whitelist: string[];
}

const authPersist: PersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token', 'user', 'inscricaoAtiva', 'cddAtivo'],
};

const agendamentosPersist: PersistConfig = {
  key: 'Agendamentos',
  storage,
  whitelist: ['pagination'],
};

const estoqueCartPersist: PersistConfig = {
  key: 'EstoqueCart',
  storage,
  whitelist: ['item'],
};

const movimentacoesEntradaPersist: PersistConfig = {
  key: 'Movimentacoes',
  storage,
  whitelist: ['pagination', 'ordenacao'],
};

const solicitacoesRetornoPersist: PersistConfig = {
  key: 'SolicitacoesRetorno',
  storage,
  whitelist: ['pagination'],
};

const estoquePersist: PersistConfig = {
  key: 'Estoque',
  storage,
  whitelist: ['pagination'],
};

const coletanocdPersist: PersistConfig = {
  key: 'ColetaNoCd',
  storage,
  whitelist: ['pagination'],
};

const EntreganocdPersist: PersistConfig = {
  key: 'EntregaNoCd',
  storage,
  whitelist: ['pagination'],
};

const OrdemCargaPagePersist: PersistConfig = {
  key: 'OrdemCargaPage',
  storage,
  whitelist: ['pagination'],
};

const TrackingPersist: PersistConfig = {
  key: 'Tracking',
  storage,
  whitelist: ['pagination'],
};

export default combineReducers({
  auth: persistReducer(authPersist, auth),
  Movimentacoes: persistReducer(movimentacoesEntradaPersist, Movimentacoes),
  SolicitacoesRetorno: persistReducer(solicitacoesRetornoPersist, MovimentacoesSaida),
  SolicitacoesRetornoItensNota,
  Estoque: persistReducer(estoquePersist, Estoque),
  ColetaNoCd: persistReducer(coletanocdPersist, ColetaNoCd),
  EntregaNoCd: persistReducer(EntreganocdPersist, EntregaNoCd),
  Produtos: produtos,
  EstoqueCart: persistReducer(estoqueCartPersist, EstoqueCart),
  Transportadoras,
  SolicitacaoRetorno,
  Motorista,
  CentrosDistribuicao,
  PedidoEntrega,
  TomadoresTransportadora,
  Fornecedor,
  CidadeOrigem,
  EstadoOrigem,
  ListarVeiculos,
  PagadorArmazenagem,
  Agendamentos: persistReducer(agendamentosPersist, Agendamentos),
  OrdemCarga,
  OrdemCargaPage: persistReducer(OrdemCargaPagePersist, OrdemCargaPage),
  EstadoCidade,
  CriaAgendamento,
  DataHoraordemDeCarga,
  DetalheVeiculo,
  Plataforma,
  Atendimentos,
  CriarAtendimento,
  AtendimentoMensagens,
  ConsultaAgendamentos,
  Agrupamentos,
  Semaphore,
  KPIAC,
  KPIEAI,
  KPIEAE,
  KPISA,
  KPISE,
  Ocorrencia,
  ProgressBarSLA,
  Notifications,
  DownloadAttachment,
  DashSla,
  Tracking: persistReducer(TrackingPersist, Tracking),
  BlackList,
  CargaDescarga,
  HorariosDisponiveis,
  DetalhesOrdemCarga,
  Depositante
});
